import { useEffect, useState } from 'react';

/**
 * Hook to detect if any modal is currently open.
 * Checks for the presence of react-responsive-modal overlay in the DOM.
 *
 * @returns boolean indicating if a modal is open
 */
export const useIsModalOpen = (): boolean => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const checkModalState = () => {
            // react-responsive-modal adds an overlay with class 'react-responsive-modal-overlay'
            const modalOverlay = document.querySelector('.react-responsive-modal-overlay');
            const isOpen = modalOverlay !== null;
            setIsModalOpen(isOpen);
        };

        // Initial check
        checkModalState();

        // Create a MutationObserver to watch for modal changes
        const observer = new MutationObserver(() => {
            checkModalState();
        });

        // Observe changes to the modal container and body (where modals are rendered)
        const modalContainer = document.querySelector('#vbs-modal-container');

        if (modalContainer) {
            observer.observe(modalContainer, {
                childList: true,
                subtree: true,
            });
        }

        // Also observe body as some modals might render there
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return isModalOpen;
};
